import React, { useEffect } from 'react'
import { Box, Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'
import VidmDocument from './vidmRepo.page'
import DocumentSearch from '../containers/vidm/document'
import Repository from './repository.page'
import { useAuthContext } from '../context/auth.context'
import { useLanguageContext } from '../context/locale.context'
import {
  dataLayerTagManager,
  eventLabelTrack,
} from '../containers/repository/repo.utils'

export default function DocumentsPage() {
  const {
    state: { authData },
  } = useAuthContext()
  const {
    state: { locale },
  } = useLanguageContext()

  useEffect(() => {
    eventLabelTrack({
      categoryId: 5,
      actionId: 0,
      label: 'Switched To Documents Page',
    })
  }, [])

  return (
    <Box>
      <Tabs
        isLazy
        onChange={index => {
          eventLabelTrack({
            categoryId: 5,
            actionId: index,
            label: 'Switched To Documents Page',
          })
          switch (index) {
            case 0:
              dataLayerTagManager('button_click', {
                viewName: 'Document Repository',
                buttonName: 'Repository',
              })
              break
            case 1:
              dataLayerTagManager('button_click', {
                viewName: 'Document Repository',
                buttonName: 'Vidm Document',
              })
              break
            case 2:
              dataLayerTagManager('button_click', {
                viewName: 'Document Repository',
                buttonName: 'Document',
              })
              break
            default:
              break
          }
        }}
      >
        <TabList>
          <Tab>{locale['Repository']}</Tab>
          {authData.organization_id === 868 ? (
            <>
              <Tab>{locale['Vidm Document']}</Tab>
              <Tab>{locale['Document']}</Tab>
            </>
          ) : null}
        </TabList>

        <TabPanels>
          <TabPanel>
            <Repository />
          </TabPanel>
          <TabPanel>
            <VidmDocument />
          </TabPanel>
          <TabPanel>
            <DocumentSearch />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
}
